module.exports = __webpack_public_path__ + "img/sign_260720945_1.17e594f4.png";